export enum InvitationStatusEnum {
  NOT_INVITED,
  INVITATION_CREATED,
  EMAIL_SENT,
  INVITATION_COMPLETED,
}
